import React from 'react'
import PropTypes from 'prop-types'
import * as Headers from './Headers'
import './Header.scss'

const HEADERS = {
  isVet: <Headers.AreYouVet />,
  benefits: <Headers.Benefits />,
  authorized: <Headers.Authorized />,
  reasonFor: <Headers.ReasonFor />,
  schedule: <Headers.Schedule />,
  visit: <Headers.Visit />,
  driveTime: <Headers.Distance />,
  tried: <Headers.Tried />,
  waitTime: <Headers.WaitTime />,
  qualify: <Headers.Qualify />,
  callNow: <Headers.CallNow />,
  knowMore: <Headers.CallNow />,
  thankYou: <Headers.ThankYou />,
  callVa: <Headers.CallVa />,
  noQualifyVa: <Headers.NoQualifyVa />
}

const Header = ({ currentQuestion, currentError }) => (
  <div className="header">
    {/* <img src={BannerPic} /> */}
    <div className="header-text container">
      <div className="">
        {currentError === undefined ? HEADERS[currentQuestion] : HEADERS[currentError]}
      </div>
    </div>
  </div>
)

Header.defaultProps = {
  currentQuestion: 'isVet',
  currentError: undefined
}

Header.propTypes = {
  currentQuestion: PropTypes.string,
  currentError: PropTypes.string
}

export default Header
